import React from "react";
import { makeStyles, Modal, Typography } from "@material-ui/core";
import { Close, Edit } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import { DepartmentForm } from "../Forms/DepartmentForm";
import { StoreContext } from "../../store/StoreContext";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    top: "25%",
    left: "35%",
    backgroundColor: "#fff",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: 350,
      left: "25%",
    },
    [theme.breakpoints.down("xs")]: {
      width: 250,
      left: "10%",
    },
  },
  closeWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  closeButton: {
    width: 30,
    height: 30,
    padding: "10px 10px 0 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      cursor: "pointer",
      color: "#aaa",
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
    marginBottom: 20,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 30px 30px",
  },
  modalTitle: {
    [theme.breakpoints.down("xs")]: {
      fontSize: 22,
    },
  },
}));

export const EditDepartmentModal = ({ departmentID, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { departments, updateDepartment } = React.useContext(StoreContext);
  const dep = departments.find((dep) => dep.id === departmentID);

  const onSubmit = async (values) => {
    const { company, departmentName: name } = values;
    if (dep.name == name && dep?.company === company) {
      console.log("No changes");
      onClose();
      return;
    }
    updateDepartment(departmentID, { name, company });
    onClose();
  };

  return (
    <div>
      <Modal open={departmentID !== null} onClose={onClose}>
        <div className={classes.modal}>
          <div className={classes.closeWrapper}>
            <div className={classes.closeButton} onClick={onClose}>
              <Close />
            </div>
          </div>
          <Typography variant="h6" className={classes.modalTitle}>
            {t("EDIT_DEPARTMENT_MODAL")}
          </Typography>
          <div>
            <DepartmentForm
              onSubmit={onSubmit}
              department={dep}
              classes={classes}
              buttonTitle={t("SAVE")}
              endIcon={<Edit />}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
